import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/company/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/company/detail', data }).then(r => r);
	},
	salesOptions: data => {
		return http({ url: '/api/admin/v1/company/salesOptions', data }).then(r => r);
	},
	review: data => {
		return http({ url: '/api/admin/v1/company/review', data, tip: true }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v1/company/update', data, tip: true }).then(r => r);
	},
	carrierCertReview: data => {
		return http({ url: '/api/admin/v1/company/carrierCertReview', data, tip: true }).then(r => r);
	},
	authorizationFile: data => {
		return http({ url: '/api/admin/v1/company/authorizationFile', method: 'get', data, responseType: 'blob' }).then(r => r);
	},
	signedAgreement: data => {
		return http({ url: '/api/admin/v1/company/signedAgreement', data, responseType: 'blob' }).then(r => r);
	},
	createServiceAgreementRequirement: data => {
		return http({ url: '/api/admin/v1/company/createServiceAgreementRequirement', data, tip: true }).then(r => r);
	},
};
